import ProductCard from "./product-card";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Food_Procesor from '../../assets/goods/explore-product/food-processor.webp';
import Coffee_Maker from '../../assets/goods/explore-product/coffee-maker.webp';
import Vaccum_Cleaner from '../../assets/goods/explore-product/vaccum-cleaner.webp';
import Air_Purifier from '../../assets/goods/explore-product/air-purifier.webp';
import Cordless_Drill from '../../assets/goods/explore-product/premium-cordless.webp';
import Portable_AC from '../../assets/goods/explore-product/premium-portable-ac.webp';
import Pressure_Cooker from '../../assets/goods/explore-product/pressure-cooker.webp';
import Thermostat from '../../assets/goods/explore-product/thermostat.webp';

// Sample data - updated for home appliances
const exploreProducts = [
  {
    id: "1",
    name: "Multi-Function Food Processor",
    image: Food_Procesor,
    price: 129.99,
    originalPrice: 169.99,
    rating: 4.5,
    reviewCount: 3654,
    discount: 25,
  },
  {
    id: "5",
    name: "Smart Coffee Maker",
    image: Coffee_Maker,
    price: 89.99,
    rating: 4.6,
    reviewCount: 1456,
    isNew: true,
  },
  {
    id: "6",
    name: "Robotic Vacuum Cleaner",
    image: Vaccum_Cleaner,
    price: 199.99,
    rating: 4.7,
    reviewCount: 2345,
  },
  {
    id: "2",
    name: "Digital Air Purifier",
    image: Air_Purifier,
    price: 149.99,
    originalPrice: 199.99,
    rating: 4.7,
    reviewCount: 1254,
    discount: 20,
  },
  {
    id: "3",
    name: "Cordless Power Drill",
    image: Cordless_Drill,
    price: 69.99,
    originalPrice: 99.99,
    rating: 4.8,
    reviewCount: 2345,
    discount: 30,
  },
  {
    id: "4",
    name: "Portable AC Unit",
    image: Portable_AC,
    price: 249.99,
    originalPrice: 329.99,
    rating: 4.2,
    reviewCount: 567,
    discount: 25,
  },
  {
    id: "7",
    name: "Electric Pressure Cooker",
    image: Pressure_Cooker,
    price: 79.99,
    rating: 4.4,
    reviewCount: 789,
  },
  {
    id: "8",
    name: "Smart Thermostat",
    image: Thermostat,
    price: 59.99,
    originalPrice: 79.99,
    rating: 4.3,
    reviewCount: 1452,
    discount: 25,
  },
];

export default function ExploreProducts() {
  return (
    <section className="my-12">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl md:text-2xl font-bold mb-4 flex items-center text-gray-800">
          <span className="w-1 h-6 bg-[#ff9906] mr-2 inline-block"></span>
          Explore Our Products
        </h2>
        <div className="flex space-x-2">
          <button className="p-2 rounded-full border border-gray-200 hover:bg-gray-100 text-gray-600">
            <ChevronLeft size={20} />
          </button>
          <button className="p-2 rounded-full border border-gray-200 hover:bg-gray-100 text-gray-600">
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {exploreProducts.map((product) => (
          <ProductCard key={product.id} {...product} />
        ))}
      </div>

      <div className="flex justify-center mt-8">
        <button className="border border-[#ff9906] text-[#ff9906] px-4 py-2 rounded-md hover:bg-[#ff9906] hover:text-white transition-colors">
          View All Products
        </button>
      </div>
    </section>
  );
}